/* ***************************************************************************************
Default color modes
*************************************************************************************** */

export default {
  Black: {
    Civilian: "black",
    Friend: "black",
    Hostile: "black",
    Neutral: "black",
    Unknown: "black",
    Suspect: "black",
  },
  Dark: {
    Civilian: "rgb(80,0,80)",
    Friend: "rgb(0,107,140)",
    Hostile: "rgb(200,0,0)",
    Neutral: "rgb(0,160,0)",
    Unknown: "rgb(225,220,0)",
    Suspect: "rgb(255, 188, 1)",
  },
  FrameColor: {
    Civilian: "rgb(255,0,255)",
    Friend: "rgb(0, 255, 255)",
    Hostile: "rgb(255, 0, 0)",
    Neutral: "rgb(0, 255, 0)",
    Unknown: "rgb(255, 255, 0)",
    Suspect: "rbg(255, 188, 1)",
  },
  IconColor: {
    Civilian: "rgb(255,0,255)",
    Friend: "rgb(0, 255, 255)",
    Hostile: "rgb(255, 0, 0)",
    Neutral: "rgb(0, 255, 0)",
    Unknown: "rgb(255, 255, 0)",
    Suspect: "rgb(255, 188, 1)",
  },
  Light: {
    Civilian: "rgb(255,161,255)",
    Friend: "rgb(128,224,255)",
    Hostile: "rgb(255,128,128)",
    Neutral: "rgb(170,255,170)",
    Unknown: "rgb(255,255,128)",
    Suspect: "rgb(255, 229, 153)",
  },
  Medium: {
    Civilian: "rgb(128,0,128)",
    Friend: "rgb(0,168,220)",
    Hostile: "rgb(255,48,49)",
    Neutral: "rgb(0,226,110)",
    Unknown: "rgb(255,255,0)",
    Suspect: "rgb(255, 217, 107)",
  },
  None: {
    Civilian: false,
    Friend: false,
    Hostile: false,
    Neutral: false,
    Unknown: false,
    Suspect: false,
  },
  OffWhite: {
    Civilian: "rgb(239, 239, 239)",
    Friend: "rgb(239, 239, 239)",
    Hostile: "rgb(239, 239, 239)",
    Neutral: "rgb(239, 239, 239)",
    Unknown: "rgb(239, 239, 239)",
    Suspect: "rgb(239, 239, 239)",
  },
  White: {
    Civilian: "white",
    Friend: "white",
    Hostile: "white",
    Neutral: "white",
    Unknown: "white",
    Suspect: "white",
  },
};
